"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["color", "size", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PolygonLineCheckIcon = function PolygonLineCheckIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14 13.525l1-1V14h1v2h-2v-1h-1.475l1-1H14zM0 14v2h2v-1h4.59l-.999-1H2V5.639l4 2.057V9h1.945L8 8.98V7.384l6-4.408V6.76l.028-.011a2.497 2.497 0 0 1 .867-.156c.035 0 .07.012.105.013V2h1V0h-2v1.735L6.833 7 2 4.514V3H0v2h1v9zm9.557-.275l-2.1-2.102-.707.707 2.807 2.81 5.692-5.692-.707-.707z"
    }));
  }

  if (size <= 24) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10.447 21H4v-1H3V7h.512L9 10.632V12h3v-1.483L20.952 4H21v9.218l.915-.364c.028-.012.057-.015.085-.025V4h1V1h-3v2.456L12 9.28V9H9v.433l-5-3.31V4H1v3h1v13H1v3h3v-1h7.464l-.859-.808a2.432 2.432 0 0 1-.158-.192zM21 2h1v1h-1zm-11 8h1v1h-1zM2 5h1v1H2zm0 17v-1h1v1zm17.444 0H20v1h3v-3h-1v-.502zM22 22h-1v-1h1zm.491-7.181l.7.715-7.684 7.522-3.531-3.32.685-.73 2.832 2.664z"
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.652 28H5v-1H4V9h.05L12 14.782V17h3v-1.52L28 5.082v13.675l1-.487V5h1V2h-3v2.6l-12 9.6V14h-2.375L5 8.455V6H2v3h1v18H2v3h3v-1h10.431l-.251-.238a2.478 2.478 0 0 1-.528-.762zM28 3h1v1h-1zM14 16h-1v-1h1zM3 7h1v1H3zm0 22v-1h1v1zm25-2.51V27h-.518l-.482.475V28h-.533l-1.015 1H27v1h3v-3h-1v-1.495zM29 29h-1v-1h1zm-8.487 2.059l-3.957-3.75.687-.725 3.256 3.084 10.048-9.898.701.711z"
  }));
};

var _default = PolygonLineCheckIcon;
exports["default"] = _default;